import { XWikiActions } from './XWikiActions'

/** Описание элементов в OWL 
 * description содержит информацию о графах. Для элементов графа фиксируется триплет
*/

const initialXWikiState = {
    state: "empty",
    wikis: [],
    nodes: [],
}
export const xwiki = (state = { ...initialXWikiState} , action) => {
  switch (action.type) {
    case "XWikiActions.EMPTY":
      return{
        ...initialXWikiState,
      };
    case "XWikiActions.LOAD_STARTED":
      return{
        ...state,
        state: "load",
    };
    case "XWikiActions.LOAD_ERROR":
      return {
        ...initialXWikiState,
        error: action.error,
        state: "error",
    };
    case "XWikiActions.WIKIS":
      return {
        ...state,
        wikis: action.wikis,
        state: "loaded",
    };
    case "XWikiActions.NODES":
      return {
        ...state,
        nodes: action.nodes,
        state: "loaded",
    };
    case "XWikiActions.SELECTED":
      return {
        ...state,
        page: action.page,
    };
    case "XWikiActions.NODEPAGES": 
      const {nodes} = state;
      const np = [... nodes];
      for (let i=0; i<np.length; i++) {
        if (np[i].nodeId == action.nodeId){
          np[i].children = action.pages;
          break;
        }
      }
      return {
        ...state,
        nodes: np,
        state: "loaded",
    };
    default:
      return state;
  }
}
